import { faFileCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import React from "react";

function NotFound() {
  return (
    <div className="legal-page">
      <section className="legal-hero" aria-labelledby="not-found-title">
        <FontAwesomeIcon
          icon={faFileCircleExclamation}
          className="legal-hero-icon legal-hero-icon-danger"
          aria-hidden="true"
        />
        <p className="section-ms-kicker">404</p>
        <h1 id="not-found-title">Page not found</h1>
        <p>
          The page you are looking for is not available. Start again from the
          MileSoft home page or use the navigation above.
        </p>
        <Link
          to="/"
          className="btn-ms btn-ms-primary btn-ms-md"
        >
          Back to Home
        </Link>
      </section>
    </div>
  );
}

export default NotFound;
